import React, { useEffect, useState } from "react";
import Security from "./Security";
import Footer from "./Footer";
import { Link, useNavigate } from "react-router-dom";
import Shearchbar from "./Shearchbar";
import Navbar from "./Navbar";
import Manubar from "./Manubar";
import secureLocalStorage from "react-secure-storage";
import axios from "axios";
import "./shubh.css";

const Blog = () => {
  let Navigate = useNavigate();
  let [showblog, setshowblog] = useState([]);

 

  useEffect(() => {
    const fetchBlogs = async () => {
      try {
        const res = await axios.get(
          `${process.env.REACT_APP_API}website/blog_list`
        );
        setshowblog(res.data.data);
      } catch (error) {
        console.log(error);
      }
    };
    fetchBlogs();
  }, []);

  return (
    <>
      <div>
        {/* header section start */}
        {/* Modal */}
        <div className="modal fade offcanvas-modal" id="exampleModal">
          <div className="modal-dialog offcanvas-dialog">
            <div className="modal-content">
              <Manubar />
            </div>
          </div>
        </div>
        <header>
          <Shearchbar />

          <Navbar />
        </header>
        {/* header section end */}
        {/* main content start */}
        {/* bread crumb section start */}
        <nav className="breadcrumb-section">
          <div className="container">
            <div className="row">
              <div className="col-12">
                <ol className="breadcrumb bg-transparent m-0 p-0 align-items-center">
                  <li className="breadcrumb-item">
                    <Link to="/">Home</Link>
                  </li>
                  <li className="breadcrumb-item active" aria-current="page">
                    Blog
                  </li>
                </ol>
              </div>
            </div>
          </div>
        </nav>
        {/* bread crumb section end */}
        <section className="section-mb">
          <div className="container">
            <div className="row mb-n7">
              {showblog?.map((items, index) => {
                return (
                  <div className="col-xl-3 col-lg-4 col-sm-6 col-md-6 mb-7">
                    <div className="blog-card">
                      <div className="thumb">
                        <a href="">
                          <img
                            className="img-fluid"
                            src={`${process.env.REACT_APP_API}uploads/${items.blog_image}`}
                            alt="img"
                          />
                        </a>
                      </div>
                      <div className="blog-content">
                        <h3 className="title">
                          <a href="#">{items.title}</a>
                        </h3>
                        <a href="#">
                          <span className="blog-meta">{items.description}</span>
                        </a>
                      </div>
                    </div>
                  </div>
                );
              })}
            </div>
          </div>
        </section>
        <Security />
        <Footer />
      </div>
    </>
  );
};

export default Blog;
